import React from 'react';
import {withRouter} from 'react-router-dom';
import {dropByCacheKey, getCachingKeys} from 'react-router-cache-route'
import {Breadcrumb} from 'antd';
import store from '../store';
import cookie from "react-cookies";
import {isEmpty} from "../common/utils/StringUtils";
import Swiper from '../messageSystem/messageSwiper'
import {USER_ID} from "../source/js/common";
// import Swiper from '../ModalDrag.js';

const AisinoBreadcrumb = (props) => {
    const { location } = props;
    const isSiderShow = props.location.pathname!=="/policy_list" & props.location.pathname!=="/faq_list" & props.location.pathname!=="/userManual" & props.location.pathname!=="/performance"
    const aStyle = {
            marginLeft: "6px",
            fontWeight: "bold",
            fontSize: "18px",
    }
    const pathSnippets = location.pathname.split('/').filter(i => i);
    var len = pathSnippets.length;
    const extraBreadcrumbItems = pathSnippets.map((_, index) => {
        const url = `/${pathSnippets.slice(0, index + 1).join('/')}`;
        const menuRoutes = store.getState().menuData.menuRoutes;
        for(var i =0;i<menuRoutes.length;i++){
            const route = menuRoutes[i].props;
            if(route.path == url){
                return (
                    <Breadcrumb.Item key={url} >
                        {route.path!=="/login" && route.path!=="/home" && isSiderShow ? <a style={aStyle} onClick={() => historyGoBack(len-index-1,route.path)} >{route.breadcrumbName}</a>:""}
                    </Breadcrumb.Item>
                );
            }

        }
    });
    const historyGoBack = (backNum,pathName) => {
        if(backNum == 0){
            return true;
        }
        props.history.go(-backNum);
        handleRoutePath(pathName);
    }
    const handleRoutePath = (data) => {
        let index = getCachingKeys().findIndex(item => data === item);
        for (let i = index + 1; i <= getCachingKeys().length - 1; i++){
            dropByCacheKey(getCachingKeys()[i])
        }
    }
    const handleHome = () => {
        getCachingKeys().forEach(item => {
            dropByCacheKey(item)
        })
    }
    const breadcrumbItems = [
        <Breadcrumb.Item key="home">
            {!isEmpty(cookie.load(USER_ID)) ? location.pathname === "/home" ?<Swiper/> : "" : ""}
        </Breadcrumb.Item>,
    ].concat(extraBreadcrumbItems);
    return (
        <div className="demo" style={{margin:"10px",overflow:"hidden"}}>
            <Breadcrumb >{breadcrumbItems}</Breadcrumb>
        </div>
    );
};
export default withRouter(AisinoBreadcrumb);
